import { Subject } from 'rxjs';
import { Input, Directive } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive()
export class FiOptionsItemBase {
    @Input() value: number;

    onSelect$ = new Subject<void>();
    selected$ = new BehaviorSubject(false);
    onClick() {
        this.onSelect$.next();
    }
}
